import { useContext } from 'react';
import { BusinessAccountContext, BusinessAccountContextType } from '@/contexts/BusinessAccountContext';

const DEFAULT_CONTEXT: BusinessAccountContextType = {
  selectedAccountId: null,
  selectedAccount: null,
  setSelectedAccountId: () => {},
  clearSelectedAccount: () => {},
  setWorkspaceAccountOverride: () => {},
  accounts: null,
  isLoading: false,
};

export function useBusinessAccountContext(): BusinessAccountContextType {
  const context = useContext(BusinessAccountContext);
  return context ?? DEFAULT_CONTEXT;
}

